import { Rol } from '@/shared/dtos/rol';
import { Component, Prop } from 'vue-property-decorator';
import { ItiBaseModal, ItiForm, ItiTextField } from '@/iti-core-vuetify';
@Component({
    components: {
        ItiForm,
        ItiTextField
    },
})
export default class RolesFormulario extends ItiBaseModal {
    @Prop() public rol!: Rol;

    public closeModalWithData(e: any) {
        this.validateAndClose(this.rol);
    }
}
